module.exports = __webpack_public_path__ + "static/media/paisagem02.870fb973.jpg";